import React, {useState, useEffect} from 'react';
import {View, Text, Animated, StyleSheet} from 'react-native';
import {Colors} from '../../../../constants/Colors';

const LinearProgress = ({
  width = 300,
  height = 20,
  progressColor = Colors.GreenPallete.greenTwo,
  backgroundColor = Colors.GrayPallete.lightgrayTwo,
}) => {
  const [progress] = useState(new Animated.Value(0)); // Armazenamos `progress` como uma Animated.Value
  const [displayProgress, setDisplayProgress] = useState(0); // Armazenar o valor exibido

  // Simula o progresso aumentando até 100%
  useEffect(() => {
    // Inicia a animação do progresso até 100%
    Animated.timing(progress, {
      toValue: 100, // Progresso até 100%
      duration: 10000, // Duração de 10 segundos
      useNativeDriver: false, // Como estamos lidando com largura, não podemos usar NativeDriver
    }).start();

    // Monitorar o valor de progresso para atualizar o texto
    const progressListener = progress.addListener(({value}) => {
      setDisplayProgress(Math.round(value));
    });

    // Limpa o listener quando o componente desmonta
    return () => {
      progress.removeListener(progressListener);
    };
  }, [progress]);

  // Interpolar a largura da barra de progresso de acordo com o valor atual
  const widthInterpolated = progress.interpolate({
    inputRange: [0, 100],
    outputRange: [0, width], // A barra de progresso vai de 0 até a largura total definida
  });

  return (
    <View style={[styles.container, {width, height, backgroundColor}]}>
      <Animated.View
        style={[
          styles.progressBar,
          {width: widthInterpolated, backgroundColor: progressColor},
        ]}
      />
      <Text style={styles.progressText}>
        {`${displayProgress}%`} {/* Exibe o valor atualizado do progresso */}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    borderRadius: 50,
    overflow: 'hidden',
  },
  progressBar: {
    height: '100%',
    borderRadius: 5,
  },
  progressText: {
    position: 'absolute',
    alignSelf: 'center',
    fontFamily: 'TCCC-UnityHeadline Regular',
    fontSize: 12,
    lineHeight: 14,
    color: 'white',
  },
});

export default LinearProgress;
